module.exports = __webpack_public_path__ + "media/day/359-91af67cd.svg";